import { render } from "./slider-note-form.vue?vue&type=template&id=549d6bd2&ts=true"
import script from "./slider-note-form.vue?vue&type=script&lang=ts"
export * from "./slider-note-form.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__